import { render, staticRenderFns } from "./PersonDeadFilterPicker.vue?vue&type=template&id=b726bbe0&scoped=true&"
import script from "./PersonDeadFilterPicker.vue?vue&type=script&lang=ts&"
export * from "./PersonDeadFilterPicker.vue?vue&type=script&lang=ts&"
import style0 from "./PersonDeadFilterPicker.vue?vue&type=style&index=0&id=b726bbe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b726bbe0",
  null
  
)

export default component.exports